import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<main class=\"grow flex flex-col overflow-x-hidden\"><div class=\"bg-gray-50 grow\"><div class=\"py-24 lg:py-32\"><div class=\"relative z-10 mx-auto max-w-7xl pl-4 pr-8 sm:px-6 lg:px-8\"><h1 class=\"text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl\">Welcome to the course!</h1><p class=\"mt-6 max-w-2xl text-xl text-gray-500\">You&#39;ll get an email once your payment is processed. This email contains a link to the README.txt, which has all the info you need to start learning.</p></div></div></div></main>", 1)

import MetaTags from '@/components/MetaTags.vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeToTheCourse',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Welcome to the course",
        description: "",
        url: "https://www.nslookup.io/welcome-to-the-course/"
      }),
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/javascript" }, {
        default: _withCtx(() => [
          _createTextVNode(" !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments); },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js', a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script'); twq('config','ogao2'); twq('event', 'tw-ogao2-ogaof', {}); ")
        ]),
        _: 1
      }))
    ])),
    _createVNode(HeaderComponent),
    _hoisted_1,
    _createVNode(FooterComponent)
  ], 64))
}
}

})